import { RefObject, useEffect, useState } from "react";

export const useScrollPosition = (ref: RefObject<HTMLElement>) => {
	const [isAtTop, setIsAtTop] = useState(true);
	const [isAtBottom, setIsAtBottom] = useState(false);

	useEffect(() => {
		const element = ref.current;
		if (!element) return;
		const updateScrollFlags = () => {
			const scrollThresholdPx = 20;
			const isScrolledToTop = element.scrollTop <= scrollThresholdPx;
			const isScrolledToBottom = element.scrollTop + element.clientHeight >= element.scrollHeight - scrollThresholdPx;
			setIsAtTop(isScrolledToTop);
			setIsAtBottom(isScrolledToBottom);
		};
		updateScrollFlags();
		element.addEventListener("scroll", updateScrollFlags, { passive: true });
		const resizeObserver = new ResizeObserver(updateScrollFlags);
		resizeObserver.observe(element);
		return () => {
			element.removeEventListener("scroll", updateScrollFlags);
			resizeObserver.disconnect();
		};
	}, [ref]);

	const scrollToTop = () => ref.current?.scrollTo({ top: 0, behavior: "smooth" });
	const scrollToBottom = () => ref.current?.scrollTo({ top: ref.current.scrollHeight, behavior: "smooth" });

	return { isAtTop, isAtBottom, scrollToTop, scrollToBottom };
};
